export enum AuthRegistrationEmailFlow {
    Registration = 'registration',
    TrustedDeviceBootstrap = 'trusted_device_bootstrap',
}
